import React, { useState } from 'react';

// 🌍 1️⃣ Tüm dillerdeki metinler
const policyContent = {
  tm: {
    title: "Gizlinlik Syýasaty",
    lastUpdated: "Soňky täzelenme: 14.09.2026",
    body: `
      Täze aý sahypasyna hoş geldiňiz. Biz siziň şahsy maglumatlaryňyzy we gizlinlik hukugyňyzy goramaga ygrarlydyrys. 
      Eger bu gizlinlik syýasaty babatda islendik soragyňyz ýa-da aladaňyz bar bolsa, 
      <a href="mailto:info@alemtilsimat.com">info@alemtilsimat.com</a> salgysy arkaly habarlaşmagyňyzy haýyş edýäris.

      <br />
      <strong>1. Biz nähili maglumatlary ýygnaýarys?</strong><br/>
      Biz hyzmatlarymyzdan peýdalananyňyzda, biz ýa-da önümlerimiz barada maglumat almaga isleg bildireniňizde ýa-da başga bir sebäp bilen habarlaşanyňyzda, 
      siziň meýletin berýän şahsy maglumatlaryňyzy ýygnaýarys. Bulara siziň adyňyz, e-poçta salgyňyz we telefon belgiňiz degişli bolup biler.

      <br />
      <strong>2. Maglumatlaryňyzy nähili ulanýarys?</strong><br/>
      Ýygnan maglumatlarymyzy hyzmatlarymyzy üpjün etmek, işletmek we goldamak, tölegleri amala aşyrmak, siziň bilen habarlaşmak we tejribäňizi gowulandyrmak üçin ulanýarys.

      <br />
      <strong>3. Siziň maglumatlaryňyz kimdir biri bilen paýlaşylarmy?</strong><br/>
      Biz maglumatlary diňe siziň razyçylygyňyz bilen, kanunlary berjaý etmek, size hyzmatlary hödürlemek ýa-da hukugyňyzy goramak üçin paýlaşýarys. 
      Biz siziň şahsy maglumatlaryňyzy satmaýarys.

      <br />
      <strong>4. Maglumatlaryňyzyň howpsuzlygyny nähili üpjün edýäris?</strong><br/>
      Biz işleýän islendik şahsy maglumatymyzyň howpsuzlygyny goramak üçin döredilen guramaçylyk we tehniki howpsuzlyk çäreler ulgamyny ulanýarys.
    `
  },
  ru: {
    title: "Политика конфиденциальности",
    lastUpdated: "Последнее обновление: 14.09.2026",
    body: `
      Добро пожаловать в Täze aý. Мы обязуемся защищать вашу личную информацию и ваше право на конфиденциальность. 
      Если у вас есть какие-либо вопросы или опасения, пожалуйста, напишите нам на 
      <a href="mailto:info@alemtilsimat.com">info@alemtilsimat.com</a>.

      <br />
      <strong>1. Какую информацию мы собираем?</strong><br/>
      Мы собираем личную информацию, которую вы добровольно предоставляете, когда пользуетесь нашими услугами, 
      проявляете интерес к нашим продуктам или связываетесь с нами. Это может включать ваше имя, адрес электронной почты и номер телефона.

      <br />
      <strong>2. Как мы используем вашу информацию?</strong><br/>
      Мы используем собранную информацию для предоставления, поддержки и улучшения наших услуг, 
      обработки платежей, общения с вами и улучшения вашего опыта.

      <br />
      <strong>3. Передаём ли мы вашу информацию кому-либо?</strong><br/>
      Мы передаём информацию только с вашего согласия, для соблюдения законов или защиты ваших прав. 
      Мы не продаём вашу личную информацию.

      <br />
      <strong>4. Как мы защищаем вашу информацию?</strong><br/>
      Мы используем организационные и технические меры безопасности для защиты обрабатываемых персональных данных.
    `
  },
  en: {
    title: "Privacy Policy",
    lastUpdated: "Last Updated: 14.09.2026",
    body: `
      Welcome to Täze aý. We are committed to protecting your personal information and your right to privacy. 
      If you have any questions or concerns about this privacy policy, please contact us at 
      <a href="mailto:info@alemtilsimat.com">info@alemtilsimat.com</a>.

      <br />
      <strong>1. What information do we collect?</strong><br/>
      We collect personal information that you voluntarily provide to us when you use our services, 
      express interest in our products, or contact us. This may include your name, email address, and phone number.

      <br />
      <strong>2. How do we use your information?</strong><br/>
      We use the information to provide, operate, and maintain our services, process payments, 
      communicate with you, and improve your experience.

      <br />
      <strong>3. Will your information be shared with anyone?</strong><br/>
      We only share information with your consent, to comply with laws, or to protect your rights. 
      We do not sell your personal information.

      <br />
      <strong>4. How do we keep your information safe?</strong><br/>
      We use organizational and technical security measures to protect any personal information we process.
    `
  }
};

// 🌐 2️⃣ Component
export default function Policy() {
  const [lang, setLang] = useState('tm');
  const content = policyContent[lang] || policyContent.en;

  return (
    <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
      {/* 🔸 Dil seçimi */}
      <div style={{ textAlign: 'right', marginBottom: '15px' }}>
        <select
          value={lang}
          onChange={(e) => setLang(e.target.value)}
          style={{
            padding: '8px 12px',
            borderRadius: '8px',
            border: '1px solid #ccc',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          <option value="tm">Türkmençe</option>
          <option value="ru">Русский</option>
          <option value="en">English</option>
        </select>
      </div>

      <h1>{content.title}</h1>
      <p><em>{content.lastUpdated}</em></p>

      <div
        style={{
            fontSize: "16px"
        }}
        dangerouslySetInnerHTML={{ __html: content.body }}
      />
    </div>
  );
}
